import { DEFAULT_ICON } from './constant';
import withBranding from './withBranding';

const {
    IconClose,
    IconDelete,
    IconPlus,
    IconResetUserp
} = Object.keys(DEFAULT_ICON).reduce((exportedIcons, key) => {
    return {
        ...exportedIcons,
        [key]: withBranding({
            iconName: key,
            DefaultIcon: DEFAULT_ICON[key]
        })
    };
}, {});

export {
    IconClose,
    IconDelete,
    IconPlus,
    IconResetUserp
};
